var map = {
	"./cisco.png": "c740",
	"./emulator.jpg": "682d",
	"./facebook.png": "07b3",
	"./gensis.png": "ce4f",
	"./skype.png": "e619",
	"./slack.jpg": "816c",
	"./web.jpg": "47d1",
	"./whats.png": "82b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae8c";